/* Cart cosmetics only. Category comes from server-rendered product tags. */
(() => {
  const brand = document.querySelector('[data-xwp-cart-brand]');
  if (!brand) return;
  const parentLogo = brand.querySelector('[data-xwp-parent-logo]');
  const womanLogo = brand.querySelector('[data-xwp-woman-logo]');
  const link = brand.closest('a');
  const rootUrl = brand.dataset.rootUrl || '/';
  let womanVisit = new URLSearchParams(location.search).get('xwp_store') === 'woman' || brand.dataset.cartKind === 'woman';
  const refresh = () => {
    const kind = document.querySelector('[data-xwp-cart-kind]')?.dataset.xwpCartKind || brand.dataset.cartKind;
    if (kind === 'mixed' || kind === 'other') womanVisit = false;
    if (kind === 'woman') womanVisit = true;
    const isWoman = kind === 'woman' || (kind === 'empty' && womanVisit);
    parentLogo.hidden = isWoman;
    womanLogo.hidden = !isWoman;
    brand.dataset.activeBrand = isWoman ? 'woman' : 'parent';
    if (link) link.href = isWoman ? '/pages/woman-minimal' : rootUrl;
  };
  refresh();
  const items = document.getElementById('main-cart-items');
  if (items) new MutationObserver(refresh).observe(items, { childList: true, subtree: true });
})();
